import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { Form } from '../../models';
import { FormInputsComponent } from '../form-inputs/form-inputs.component';

@Component({
    selector: 'lib-form',
    templateUrl: './form.component.html',
    standalone: true,
    imports: [FormsModule, ReactiveFormsModule, FormInputsComponent, TranslateModule, ButtonModule]
})
export class FormComponent implements OnInit, OnDestroy {
    @Input({ required: true }) form!: Form;
    @Output() save: EventEmitter<unknown> = new EventEmitter();
    @Output() clear: EventEmitter<unknown> = new EventEmitter();

    @ViewChild('htmlInputSubmit')
    private _submitElement!: ElementRef<HTMLInputElement>;

    ngOnInit(): void {
        this.form.submit = () => {
            this._submitElement.nativeElement.click();
        };
    }

    showFooter(): boolean {
        return !!this.form.footer;
    }

    showClearButton(): boolean {
        return (this.form.footer && this.form.footer?.clear !== undefined) || false;
    }

    isSubmitDisabled(): boolean {
        return (this.form.footer && this.form.footer?.submit?.disabled) || false;
    }

    resetForm(): void {
        this.clear.emit();
        this.form.reset();
    }

    ngOnDestroy(): void {
        if (!this.form.skipDestroy) {
            this.form.onDestroy();
        }
    }
}
